module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    staticClass: "inpText",
    attrs: {
      "clearable": "clearable",
      "size": "medium",
      "placeholder": _vm.plaText
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.id),
      callback: function($$v) {
        _vm.id = $$v
      },
      expression: "id"
    }
  }, _vm._l((_vm.selectArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-2242c3b6"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/inCComps/dcSelect.vue
// module id = 1432
// module chunks = 1